import type { FC } from 'react';
import type { PaginationProps } from './Pagination.types';
import { Button, ButtonGroup, Flex, Text } from '@/_components';

export const Pagination: FC<PaginationProps> = ({
  onNext,
  onPrevious,
  activePage,
  pageCount,
}) => {
  const isPreviousDisabled: boolean = activePage === 0;
  const isNextDisabled: boolean = activePage + 1 >= pageCount;

  const onPreviousClick = () => {
    if (isPreviousDisabled) return;

    return onPrevious?.();
  };

  const onNextClick = () => {
    if (isNextDisabled) return;

    return onNext?.();
  };

  return (
    <Flex isWrapping={true} isCentered={true}>
      <ButtonGroup>
        <Button
          iconLeft="arrow-left"
          isDisabled={isPreviousDisabled}
          value="Previous"
          size="small"
          intent="secondary"
          onClick={onPreviousClick}
        />
        <Text type="small" color="secondary">
          Page {activePage + 1}
        </Text>
        <Button
          iconRight="arrow-right"
          isDisabled={isNextDisabled}
          value="Next"
          size="small"
          intent="secondary"
          onClick={onNextClick}
        />
      </ButtonGroup>
    </Flex>
  );
};
